import { render, staticRenderFns } from "./BaixarCotacao.vue?vue&type=template&id=6bcf877e&scoped=true"
import script from "./BaixarCotacao.vue?vue&type=script&lang=js"
export * from "./BaixarCotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf877e",
  null
  
)

export default component.exports